<template>
    <div class="table-responsive bg-white h-100" style="max-width: max-content;">
        <table class="table table-borderless">
            <thead>
            <tr>
                <th class="position-sticky bg-white left"></th>
                <th class="th-row-cover position-sticky top" v-for="(dateStr,index) in headers" :key="index">
                    <div class="header-cover text-center" :class="itemPos.dateStr === dateStr ? highLightBadge : ''">
                        {{ dateStr.substring(5, 10) }}
                    </div>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item) in side_locations" :key="item.id">
                <th class="position-sticky bg-white left pt-2 th-col-cover" :class="shorterName ? 'th-col-width' : ''"
                    @click="shorterName=!shorterName">
                    <div class="text-left text-truncate"
                         :class="itemPos.locationId===item.id ? highLightBadge : ''"
                         data-toggle="tooltip"
                         :title="item.label">
                        {{ item.label }}
                    </div>
                </th>
                <td v-for="(dateStr) in headers"
                    :key="`${item.id}${dateStr}`"
                    :id="`${item.id}*${dateStr}`"
                    class="lazy-load position-relative"
                    @click="deliverClick(item.id, dateStr)">
                    <template v-if="visible[`${item.id}*${dateStr}`]===true">
                        <LoadRateCell
                            :ref="`${item.id}#${dateStr}`"
                            @cellClick="setItemPos(item.id, dateStr)"
                            :location-id="item.id"
                            :date-str="dateStr">
                        </LoadRateCell>
                        <diagonal-stripe-texture v-if="`${item.id}` in downtimeCalendar"
                                                 :location-id="item.id"
                                                 :date-str="dateStr"
                                                 @click="setItemPos(item.id, dateStr)"/>
                    </template>

                </td>
            </tr>
            </tbody>
        </table>

        <ReBModal ref="calendarManageModal" header="加班" @ok="submitCalendarChange">
            <div v-if="calendarManagement && selectedCell.locationId != null" class="d-flex flex-column">
                <KeyValueCell
                    class="mt-1"
                    horizontal
                    :value="main_data[selectedCell.locationId].workCenterName+'-'+main_data[selectedCell.locationId].workStationName">
                    工位
                </KeyValueCell>
                <KeyValueCell class="mt-1" horizontal :value="selectedCell.dateStr">日期</KeyValueCell>
                <el-time-picker
                    class="mt-1"
                    is-range
                    v-model="calendarManage.timeRange"
                    :clearable="false"
                    value-format="HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围">
                </el-time-picker>
                <div class="d-flex flex-row m-1">
                    <b-badge variant="secondary" v-for="(item,index) of calendarManage.pickOption" :key="index"
                             class="m-1 cursor-pointer"
                             @click="calendarManage.timeRange=item.value">
                        {{ item.label }}
                    </b-badge>
                </div>
                <diverse-input :value.sync="calendarManage.hours"
                               :config="calendarManage.inputConfig"
                               class="w-75"></diverse-input>
            </div>
        </ReBModal>

        <ReBModal ref="shiftRuleModal" header="工厂排班" @ok="submitShiftRule">
            <div v-if="addShiftRule && selectedCell.locationId != null" class="d-flex flex-column">
                <KeyValueCell
                    class="mt-1"
                    horizontal
                    :value="main_data[selectedCell.locationId].workCenterName+'-'+main_data[selectedCell.locationId].workStationName">
                    工位
                </KeyValueCell>
                <KeyValueCell class="mt-1" horizontal :value="selectedCell.dateStr">日期</KeyValueCell>
                <KeyValueCell
                    class="mt-1" horizontal :value="shiftRule.selectedRow.name"
                    click-able @valueClick="$refs.shiftRuleEntitySelector.showModal()">
                    排班规则
                </KeyValueCell>
            </div>
        </ReBModal>

        <EmModalNormalInputEntitySelector ref="shiftRuleEntitySelector" entity="sithMesMstShiftRule"
                                          @entityModalSelectSelected="shiftRuleSelected"></EmModalNormalInputEntitySelector>
    </div>
</template>

<script>
import LoadRateCell from "@/components/echarts-part/CalendarShift/cells/LoadRateCell";
import {subMapOf} from '@/components/echarts-part/CalendarShift/cells/utils/LoadRateUtil';
import {mapState} from "vuex";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import KeyValueCell from "@/views/sithMes/prd/PrdOperationExcute/cells/KeyValueCell";
import "@/components/echarts-part/CalendarShift/cells/stuffs/positions.css";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput";
import EmModalNormalInputEntitySelector from "@/components/em/EmModal/NormalInputEntitySelector";
import DiagonalStripeTexture from "@/components/echarts-part/CalendarShift/cells/stuffs/DiagonalStripeTexture.vue";

export default {
    name: "LoadRateMatrix",
    components: {
        DiagonalStripeTexture,
        EmModalNormalInputEntitySelector, DiverseInput, KeyValueCell, ReBModal, LoadRateCell
    },
    props: {
        headers: {
            type: Array,
            required: true
        },
        side_locations: {
            type: Array,
            required: true
        },
        main_data: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            locateOperationPos: state => state.calendarShift.locateOperationPos,
            needScroll: state => state.calendarShift.needScroll,
            calendarManagement: state => state.calendarShift.calendarManagement,
            addShiftRule: state => state.calendarShift.addShiftRule,
            downtimeCalendar: state => state.calendarShift.downtimeCalendar,
        }),
        itemPos() {
            let pos = this.$store.state.calendarShift.itemPos;
            return pos == null ? {locationId: '', dateStr: ''} : pos;
        }
    },
    watch: {
        needScroll(val) {
            if (val) {
                if (this.locateOperationPos != null) {
                    let el = document.getElementById(this.locateOperationPos);
                    if (el !== null) {
                        el.scrollIntoView({block: 'center', inline: 'center'});
                    } else {
                        this.$message.warning('工序不在可视范围内');
                    }
                }
                this.$store.commit('calendarShift/setNeedScroll', false)
            }
        }
    },
    data() {
        return {
            highLightBadge: 'badge badge-warning',
            io: null,
            visible: {},
            selectedCell: {
                locationId: null,
                dateStr: null,
            },
            calendarManage: {
                timeRange: null,
                hours: 0,
                pickOption: [
                    {label: '08:00-16:30', value: ['08:00:00', '16:30:00']},
                    {label: '16:00-24:00', value: ['16:00:00', '23:59:59']}
                ],
                inputConfig: {
                    label: '加班工时(H)',
                    type: 'input'
                }
            },
            shorterName: false,
            shiftRule: {
                selectedRow: {
                    name: '请点击选择排班规则'
                }
            }
        }
    },
    mounted() {
        this.observeLazyLoad()
    },
    methods: {
        setItemPos(locationId, dateStr) {
            this.$store.commit('calendarShift/setItemPos', {
                locationId: locationId,
                dateStr: dateStr
            });
        },
        posData(locationId, dateStr) {
            return subMapOf(this.main_data[locationId])[dateStr];
        },
        observeLazyLoad() {
            let elements = document.getElementsByClassName('lazy-load');
            for (let el of elements) {
                this.observe(el)
            }
        },
        observe(element) {
            if (this.io == null) {
                this.io = new IntersectionObserver(entries => {
                    for (let entry of entries) {
                        this.$set(this.visible, entry.target.id, entry.intersectionRatio !== 0);
                    }
                });
            }
            this.io.observe(element);
            return true;
        },
        changeSideLocation(list) {
            for (let item of list) {
                if (item.active) {
                    for (let date of this.headers) {
                        this.io.observe(document.getElementById(item.id + '*' + date))
                    }
                }
            }
        },
        //传递点击事件
        deliverClick(locationId, dateStr) {
            let ref = locationId + '#' + dateStr;
            let cell = this.$refs[ref][0];
            this.selectedCell.locationId = locationId;
            this.selectedCell.dateStr = dateStr;
            if (this.calendarManagement) {
                //处理加班请求
                this.$refs.calendarManageModal.showModal();
            } else if (this.addShiftRule) {
                this.$refs.shiftRuleModal.showModal();
            } else if (cell != null) {
                cell.cellClick();
            }
        },
        submitCalendarChange() {
            if (this.calendarManage.timeRange == null || Number.parseFloat(this.calendarManage.hours) <= 0) {
                this.$message.error("输入信息不全");
                return;
            }
            this.$store.dispatch('api/put', {
                url: process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstCalendar",
                entity: {
                    calendarType: 3,//加班
                    beginTime: this.selectedCell.dateStr + " " + this.calendarManage.timeRange[0],
                    endTime: this.selectedCell.dateStr + " " + this.calendarManage.timeRange[1],
                    mstLocationId: this.selectedCell.locationId,
                    ratedWorkingHours: this.calendarManage.hours
                }
            }).then(response => {
                console.log(response);
                this.$message.success("操作成功");
            })
        },
        shiftRuleSelected(row) {
            console.log(row);
            this.shiftRule.selectedRow = row;
        },
        submitShiftRule() {
            if (this.shiftRule.selectedRow.id === undefined) {
                this.$message.warning("请选择排班规则");
                return;
            }
            this.$store.dispatch('api/put', {
                url: process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstLocationShiftRule",
                entity: {
                    mstLocationId: this.selectedCell.locationId,
                    mstShiftRuleId: this.shiftRule.selectedRow.id,
                    beginDate: this.selectedCell.dateStr + " 00:00:00"
                }
            }).then(response => {
                console.log(response);
                this.$message.success("操作成功");
            })
        }
    }
}
</script>

<style scoped>

.th-row-cover {
    min-width: 72px;
}

.th-col-cover {
    max-width: max-content;
    overflow: hidden;
    height: 42px;
    z-index: 1;
}

.th-col-width {
    max-width: 4rem !important;
}

.header-cover {
    /*width: 70px;*/
}

.table .badge {
    margin: 0 0.5rem;
}

.left .badge {
    margin: auto;
}

.lazy-load {

}
</style>
